<template>
    <SectionBase v-bind="$attrs"
                 :section="section"
                 class="ufo-sec--header-main"
                 :data-style-id="section._id"
    >
        <div v-if="!portfolioHasNavigationSection" class="grid">
            <GetSiteNavigation :section="section" />
        </div>

        <div :class="['grid', 'ufo--hero-content-grid', {'is-vertical-layout': isVerticalLayout}]" :style="rowStyle">

            <template v-for="module in visibleModules()" :key="module.moduleId">
                <div :class="['col', setHorizontalPosition, setVerticalPosition]"
                     :style="[columnSettings(module)]"
                >

                    <Title v-if="module.type === moduleTypes.TITLE" :section="section" />

                    <div v-if="module.type === moduleTypes.MEDIA && section.media"
                         :class="['image-container', mediaSize]">
                        <AnimationWrapper>
                            <template #animationContent>
                                <Media :section="section" />
                            </template>
                        </AnimationWrapper>
                    </div>

                </div>
            </template>
        </div>
    </SectionBase>
</template>

<script>
    import SectionBase from "./SectionBase.vue";
    import GetMediaContent from "./_helper/GetMediaContent.vue";
    import GetSiteNavigation from "./_helper/GetSiteNavigation.vue";
    import AnimationWrapper from "../../../common/components/AnimationWrapper.vue";
    import {MockupOrientation} from "@/scripts/common/mockupStore/mockupStructure.js";
    import {updateSectionLevelColorCssInHead} from "@/scripts/common/TextStyleRenderHelper.js";
    import {HeroContentFlowEnum, SectionModuleTypeEnum} from "@/scripts/common/enums.js";
    import { resolveRowSpan } from "@/scripts/common/utilities/layout.js";
    import Title from "@/scripts/view/portfolio/sections/modules/Title.vue";
    import Media from "@/scripts/view/portfolio/sections/modules/Media.vue";
    import {mapGetters} from "vuex";

    export default {
        name: "MainHeader",
        components: {
            Media,
            Title,
            SectionBase,
            AnimationWrapper, GetSiteNavigation, GetMediaContent},
        props:['section'],
        data() {
            return {
                moduleTypes: SectionModuleTypeEnum
            }
        },
        beforeMount() {
            if(!this.$route.query.templatePreview) {
                updateSectionLevelColorCssInHead(this.section)
            }
        },
        methods: {
            visibleModules() {
                return this.section.layoutSettings?.modules.filter(module => module.type !== SectionModuleTypeEnum.SPACER)
            },
            columnSettings(module) {
                const { rowStart, rowEnd } = resolveRowSpan(module.gridSettings);
                return {
                    '--columnStart': module.gridSettings?.columnStart,
                    '--columnEnd': module.gridSettings?.columnEnd,
                    '--rowStart': rowStart,
                    '--rowEnd': rowEnd,
                    '--height': module.gridSettings?.height ? `${module.gridSettings?.height}px` : null,
                    '--mediaHeight': module.gridSettings?.mediaHeight ? `${module.gridSettings?.mediaHeight}px` : null
                }
            }
        },
        computed: {
            ...mapGetters("view", ["viewData"]),
            ...mapGetters(["portfolioHasNavigationSection"]),
            textAlignment() {
                return `align-text-${this.section.title.style?.textAlign}`
            },
            rowStyle() {
                return {
                    '--rowSize': !this.isVerticalLayout && this.section.styleSettings?.sectionHeight
                        ? `${this.section.styleSettings.sectionHeight}px`
                        : null,
                }
            },
            setHorizontalPosition() {
                if (this.section.title.style?.left === 0) {
                    return 'left'
                } else if (this.section.title.style?.left === 100) {
                    return 'right'
                }
            },
            setVerticalPosition() {
                if (this.section.title.style?.top === 0) {
                    return 'top'
                } else if (this.section.title.style?.top === 100) {
                    return 'bottom'
                } else {
                    return 'center'
                }
            },
            mediaSize() {
                return !!this.section.media && !!this.section.media.displayMode
                    ? `media-${this.section.media.displayMode}`
                    : null;
            },
            isVerticalLayout() {
                return this.section?.layoutSettings?.contentFlow === HeroContentFlowEnum.VERTICAL;
            }
        }
    }
</script>

<style lang="scss" scoped>
@media (min-width: 1024px) {
    .text-container div div:last-child {
        margin-bottom: 0;
    }
}
</style>
